import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable, of, timer } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { KommoService } from '../../../../core/services/kommo/kommo.service';

export function kommoBotAsyncValidator(kommoService: KommoService): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    const value = control.value;

    if (!value || value === '') {
      return of(null);
    }

    return timer(400).pipe(
      switchMap(() => kommoService.validateBot(value)),
      map(response => {
        if (response.success && response.data.valid) {
          return null;
        }
        return { botInvalid: true };
      }),
      catchError(() => of({ botValidationError: true }))
    );
  };
}
